import { render, staticRenderFns } from "./pencilbutton.vue?vue&type=template&id=104f9542&"
import script from "./pencilbutton.vue?vue&type=script&lang=js&"
export * from "./pencilbutton.vue?vue&type=script&lang=js&"
import style0 from "./pencilbutton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports